'use client';

import { createInstance, type Resource } from 'i18next';
import type { PropsWithChildren } from 'react';
import { I18nextProvider } from 'react-i18next';

import { DEFAULT_NS } from '@/modules/localization';
import { initTranslations } from '@/modules/localization/utils/i18n';

interface TranslationsProviderProps {
  locale: string;
  defaultNS?: string;
  namespaces?: string[];
  resources?: Resource;
}

export default function TranslationsProvider({
  namespaces,
  resources,
  children,
  locale,
}: PropsWithChildren<TranslationsProviderProps>) {
  const instance = createInstance();
  initTranslations(locale, namespaces, instance, resources);

  return (
    <I18nextProvider defaultNS={DEFAULT_NS} i18n={instance}>
      {children}
    </I18nextProvider>
  );
}
